import { render, staticRenderFns } from "./create-or-edit-product.vue?vue&type=template&id=753f52cb"
import script from "./create-or-edit-product.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-product.ts?vue&type=script&lang=js&external"
import style0 from "./create-or-edit-product.vue?vue&type=style&index=0&id=753f52cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports